<mat-card>
  <mat-card-header>
    <mat-card-title>Configuración de Expensas</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <form [formGroup]="form0Group">

        <mat-expansion-panel [expanded]="true" hideToggle="true">
          
          <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 20px;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="Comunidad" [compareWith]="compareComunidades">
                  <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!form0Group.controls['Comunidad'].valid && form0Group.controls['Comunidad'].touched">
                  {{ getError0Comunidad() }}
                </mat-error>
              </mat-form-field>
            </div>
            
          </div>
          
          <div fxLayout="row-reverse stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="onComunidadConfigure()" [disabled]="isSaving" color="primary" class="zb-button">Configurar</button>
          </div>
            
        </mat-expansion-panel>

        <br/>

      </form>

      <ng-container *ngIf="(comunidadSeleccionada != null && comunidadSeleccionada.Id > 0)">

        <mat-expansion-panel [expanded]="step===1" (opened)="setStep(1)" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">flag</mat-icon> PASO 1: Configuración de Consorcio y {{'Comunidad' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="form1Group">

            <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 10px;">
                <mat-label style="text-align: center; font-weight: bold;">¿Qué tipos de gastos utilizará la {{('Comunidad' | translate).toLowerCase()}}?</mat-label>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                <form [formGroup]="tiposGastosFormGroup">

                  <div fxLayout="row stretch" fxLayout.xs="column">
      
                    <div fxFlex=45 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isTiposGastosSearching && !isComunidadTiposGastosSearching">Tipo de Gasto</mat-label>
                        <mat-label *ngIf="isTiposGastosSearching || isComunidadTiposGastosSearching">Cargando...</mat-label>
                        <mat-select formControlName="TipoGastoId">
                          <mat-option *ngFor="let s of tiposGastosList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="!tiposGastosFormGroup.controls['TipoGastoId'].valid && tiposGastosFormGroup.controls['TipoGastoId'].touched">
                          {{ getErrorTipoGastoId() }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex=45 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-top: 15px;">
                      <!-- <mat-form-field appearance="outline" style="width: 100%"> -->
                        <mat-checkbox formControlName="MostrarEnResumenExpensa">Mostrar el gasto en las columnas de expensas</mat-checkbox>
                      <!-- </mat-form-field> -->
                    </div>
                    <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <button mat-raised-button (click)="onTipoGastoAdd()" color="primary"
                          class="zb-button">Agregar</button>
                      </div>
                    </div>
      
                  </div>
      
                </form>

              </div>
    
              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <ejs-grid #tiposGastosGrid [dataSource]="form1Group.get('TipoGastos')?.value" [allowPaging]="true" [allowSorting]="true"
                  [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                  [allowResizing]='true'>
                  <e-columns>
                    <e-column field='TipoGasto' headerText='Tipo Gasto' width="200"></e-column>
                    <e-column field='MostrarEnResumenExpensa' headerText='Mostrar en Expensas' width="70">
                      <ng-template #template let-data>
                        {{data.MostrarEnResumenExpensa ? 'Sí' : 'No'}}
                      </ng-template>
                    </e-column>
                    <e-column headerText='Acciones' width="70">
                      <ng-template #template let-data>
                        <a style="cursor: pointer;" (click)="onTipoGastoDelete(data)" title="Eliminar tipo de gasto">
                          <i class="fa fa-trash fa-1x"></i>
                        </a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>

            </div>

            <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

            <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 10px;">
                <mat-label style="text-align: center; font-weight: bold;">¿Qué parámetros se utilizarán al momento de calcular las expensas?</mat-label>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="isConsorcioSearching">
                <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
              </div>

              <ng-container *ngIf="!isConsorcioSearching">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Interés Vencimiento*</mat-label>
                    <input matInput formControlName="InteresVencimiento" type="number" (keyup.enter)="onStep1Guardar()">
                  </mat-form-field>
                  <mat-error *ngIf="!form1Group.controls['InteresVencimiento'].valid && form1Group.controls['InteresVencimiento'].touched">
                    {{ getErrorInteresVencimiento() }}
                  </mat-error>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Interés Mensual*</mat-label>
                    <input matInput formControlName="InteresMensual" type="number" (keyup.enter)="onStep1Guardar()">
                  </mat-form-field>
                  <mat-error *ngIf="!form1Group.controls['InteresMensual'].valid && form1Group.controls['InteresMensual'].touched">
                    {{ getErrorInteresMensual() }}
                  </mat-error>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isMetodosRedondeoExpensaSearching">Método Redondeo de Expensas*</mat-label>
                    <mat-label *ngIf="isMetodosRedondeoExpensaSearching">Cargando...</mat-label>
                    <mat-select formControlName="MetodoRedondeoExpensa">
                      <mat-option *ngFor="let s of metodosRedondeoExpensaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form1Group.controls['MetodoRedondeoExpensa'].valid && form1Group.controls['MetodoRedondeoExpensa'].touched">
                      {{ getErrorMetodoRedondeoExpensa() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isConceptosRecargoSearching">Concepto de Recargo*</mat-label>
                    <mat-label *ngIf="isConceptosRecargoSearching">Cargando...</mat-label>
                    <mat-select formControlName="ConceptosRecargo" (selectionChange)="onConceptoRecargoChange()">
                      <mat-option *ngFor="let s of conceptosRecargoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form1Group.controls['ConceptosRecargo'].valid && form1Group.controls['ConceptosRecargo'].touched">
                      {{ getErrorConceptosRecargo() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="mostrarSeleccionConceptosRecargo">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isTiposGastosSearching && !isComunidadTiposGastoConceptoRecargoSearching">Gastos del Concepto de Recargo*</mat-label>
                    <mat-label *ngIf="isTiposGastosSearching && isComunidadTiposGastoConceptoRecargoSearching">Cargando...</mat-label>
                    <mat-select formControlName="TipoGastosConceptosRecargo" multiple [compareWith]="compareTipoGastosConceptosRecargo">
                      <mat-option *ngFor="let s of tiposGastosList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form1Group.controls['TipoGastosConceptosRecargo'].valid && form1Group.controls['TipoGastosConceptosRecargo'].touched">
                      {{ getErrorTipoGastosConceptosRecargo() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-bottom: 15px; margin-top: 15px;">
                  <mat-checkbox formControlName="ValidarUfTotalPorcentaje" (keyup.enter)="onGuardar()" color="primary">Validar Porcentaje de {{'UnidadFuncional' | translate}}</mat-checkbox> 
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nota Expensas</mat-label>
                    <textarea matInput formControlName="NotaExpensas" rows="6"></textarea>
                    <mat-error *ngIf="!form1Group.controls['NotaExpensas'].valid && form1Group.controls['NotaExpensas'].touched">
                      {{ getErrorNotaExpensas() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nota en Pie de Expensas</mat-label>
                    <textarea matInput formControlName="NotaExpensasPie" rows="6"></textarea>
                    <mat-error *ngIf="!form1Group.controls['NotaExpensasPie'].valid && form1Group.controls['NotaExpensasPie'].touched">
                      {{ getErrorNotaExpensasPie() }}
                    </mat-error>
                  </mat-form-field>
                </div>

              </ng-container>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
              <button mat-raised-button (click)="onStep1Guardar()" [disabled]="isSaving" color="primary" class="zb-button">{{isSaving && step===1 ? 'Guardando...' : 'Siguiente'}}</button>
            </div>

          </form>

        </mat-expansion-panel>

        <br />

        <mat-expansion-panel [expanded]="step===2" (opened)="setStep(2)" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">meeting_room</mat-icon> PASO 2: Porcentajes de {{'UnidadFuncional' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
            <mat-label *ngIf="isUfSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            <mat-label *ngIf="!isUfSearching && (ufPorcentajesList == null || ufPorcentajesList.length == 0)">No hay unidades funcionales en la {{('Comunidad' | translate).toLowerCase()}} seleccionada</mat-label>
          </div>
          
          <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column" *ngIf="!isUfSearching && (ufPorcentajesList != null && ufPorcentajesList.length > 0)">
            
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin: 10px;">
              <mat-label style="font-weight: bold;">Ingresa los porcentajes correspondientes de cada unidad funcional para cada gasto en cada cuadro de texto de la grilla:</mat-label>
            </div>
            
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <ejs-grid #ufPorcentajeGrid [dataSource]='ufPorcentajesList' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
                <e-columns>
                  <e-column field="UnidadFuncionalNumero" headerText='Nro. UF' width="90"></e-column>
                  <e-column headerText='Cód. UF' width="90"></e-column>
                  <e-column headerText='Tipo Unidad' width="120"></e-column>
                  <ng-container *ngIf="ufPorcentajesList != null && ufPorcentajesList.length > 0">
                    <ng-container *ngFor="let gasto of ufPorcentajesList[0]?.TipoGastoPorcentajes">
                      <e-column field="{{gasto?.TipoGastoId}}" headerText='{{gasto?.TipoGasto}}' width="100"></e-column>
                    </ng-container>
                  </ng-container>
                </e-columns>
                <ng-template #rowTemplate let-data>
                  <tr class="e-row">
                    <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalNumero}}</td>
                    <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalCodigo}}</td>
                    <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalTipo}}</td>
                    <ng-container *ngFor="let gasto of data?.TipoGastoPorcentajes">
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input matInput type="number" [(ngModel)]="gasto.Porcentaje" style="padding: 4px 2px; width: 90%; border: 1px black solid; background-color: white; text-align: right;">
                      </td>
                    </ng-container>
                  </tr>
                </ng-template>
                <e-aggregates>
                  <e-aggregate>
                    <e-columns>
                      <e-column field="UnidadFuncionalNumero" type="count">
                        <ng-template #footerTemplate let-data>
                          <mat-label style="padding-top: 0px !important;">Cantidad: {{data.count}}</mat-label>
                        </ng-template>
                      </e-column>
                      <ng-container *ngIf="ufPorcentajesList != null && ufPorcentajesList.length > 0">
                        <ng-container *ngFor="let gasto of ufPorcentajesList[0]?.TipoGastoPorcentajes">
                          <e-column field="{{gasto?.TipoGastoId}}" type="Custom" textAlign='Right'>
                            <ng-template #footerTemplate let-data>
                              <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                                {{sumUfPorcentaje(gasto.TipoGastoId) | number:'1.2-2'}}%
                              </mat-label>
                            </ng-template>
                          </e-column>
                        </ng-container>
                      </ng-container>
                    </e-columns>
                  </e-aggregate>
                </e-aggregates>
              </ejs-grid>
              
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px; text-align: center;">
            <button mat-raised-button (click)="setStep(1)" [disabled]="isSaving" color="warn" class="zb-button">Atrás</button>
            <button mat-raised-button (click)="onStep2Guardar(2)" [disabled]="isSaving" color="primary" class="zb-button">{{isSaving && step===2 ? 'Guardando...' : 'Siguiente'}}</button>
          </div>

        </mat-expansion-panel>

        <br />

        <mat-expansion-panel [expanded]="step===3" (opened)="setStep(3)" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">lock</mat-icon> PASO 3: Relación entre tipos de gastos y servicios
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="hayUfsSinCubrirTotal" style="margin-bottom: 15px;">
            <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: lightblue; padding-bottom: 15px;">
              <mat-label style="font-weight: bold; text-align: center; padding-top: 15px;">
                <u>NOTA:</u> hay porcentajes de unidades funcionales que no suman el 100% de prorrateo para los gastos. Volvé al paso 2 si queres revisar estos valores.
              </mat-label>
            </div>
          </div>

          <form [formGroup]="form3Group">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=40 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoGastoComunidadSearching">Tipos de Gasto*</mat-label>
                  <mat-label *ngIf="isTipoGastoComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoGasto" (selectionChange)="onTipoGasto3Select()">
                    <mat-option *ngFor="let s of comunidadTipoGastoList" [value]="s">{{s.TipoGasto}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!form3Group.controls['TipoGasto'].valid && form3Group.controls['TipoGasto'].touched">
                    {{ getError3TipoGastos() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isServicioSearching">Servicios*</mat-label>
                  <mat-label *ngIf="isServicioSearching">Cargando...</mat-label>
                  <mat-select formControlName="Servicios" multiple [compareWith]="compareServicios">
                    <mat-option *ngFor="let s of serviciosList" [value]="s">{{s.Nombre}} <!-- - {{s.CategoriaGastoNombre}} --></mat-option>
                  </mat-select>
                  <mat-error *ngIf="!form3Group.controls['Servicios'].valid && form3Group.controls['Servicios'].touched">
                    {{ getError3Servicios() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
                <button mat-raised-button (click)="onTipoGastoServicioAdd()" [disabled]="isSaving" color="primary" class="zb-button">Guardar</button>
              </div>
    
            </div>

          </form>

          <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

          <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
            <mat-label *ngIf="isComunidadTipoGastoServicioSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>

            <ejs-grid #tipoGastoServicioGrid [dataSource]='comunidadTipoGastoServicioList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' 
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
              <e-columns>
                <e-column field='TipoGasto' headerText='Tipo Gasto' width=110></e-column>
                <e-column headerText='Servicios' width=200>
                  <ng-template #template let-data>
                    {{ getServiciosConcat(data) }}
                  </ng-template>
                </e-column>
                <e-column headerText='Acciones' width=70>
                  <ng-template #template let-data>
                    <a style="cursor: pointer;" (click)="onTipoGastoServicioDelete(data)" title="Eliminar"><i class="fa fa-trash fa-1x"></i></a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>

          <br/>

          <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
            <button mat-raised-button (click)="setStep(2)" [disabled]="isSaving" color="warn" class="zb-button">Atrás</button>
            <button mat-raised-button (click)="onStep3Guardar()" [disabled]="isSaving" color="primary" class="zb-button">{{isSaving && step===3 ? 'Guardando...' : 'Finalizar'}}</button>
          </div>

        </mat-expansion-panel>

      </ng-container>

    </ng-container>

    <br />
    
    <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
      <button mat-raised-button (click)="onCancel()" [disabled]="isSaving" color="warn" class="zb-button">Cerrar</button>
    </div>

  </mat-card-content>
</mat-card>